<template>
    <div class="TTL-switch">
    <el-switch v-model="inputvalue" :active-text="option.title" @change="ChangeData" />
    </div>
</template>

<script>
export default {
  props: ['value','option'],
  data() {
      return {
          inputvalue:false,
          option: {
              title:this.option && this.option.title ? this.option.title : '',
          },
      }
  },

  watch: {
   
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      ChangeData() {
          this.$emit('finish',{type:'change',value:this.inputvalue});
      },

  }

}
</script>

<style scoped>
::v-deep(.el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
</style>